import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import GoogleGeolocationRegion from './GoogleGeolocationRegion'
import FacebookGeolocationRegion from './FacebookGeolocationRegion'
import RadioBlock from '../../../../components/Form/RadioBlock'
import TiktokGeolocationRegion from './TiktokGeolocationRegion'
import DV360GeolocationRegion from './DV360GeolocationRegions'
import Field from '../../../../components/Form/Field'

import { choicesCountriesSelector } from '../../../../modules/selectors/choices'

import { SHOW_OPTION, SHOW_COUNTRY_CHOICE, SHOW_REGIONS, SHOW_OPTION_REGIONS } from '../fields'

import {
  DV_360_PLATFORM,
  FACEBOOK_PLATFORM,
  GOOGLE_PLATFORM,
  TIKTOK_PLATFORM
} from '../../../../constants/selectLists/platformList'

const RegionsRadioBlock = ({ formik, formattedCountries, showRegionsCountryFilter, platform }) => {
  const { t } = useTranslation()
  const { values, errors, touched, setFieldValue } = formik

  const regionsError = errors[SHOW_REGIONS]
  const regionsTouched = touched[SHOW_REGIONS]

  const selectedRegions = values[SHOW_REGIONS]
  const countryChoice = values[SHOW_COUNTRY_CHOICE]

  const countries = useSelector(choicesCountriesSelector)

  // Find the country selected by user in countries array
  // and after that dispatch getChoicesGeolocations action
  // with country code for proper sorting in regions select
  const userChoiceCountry = countries.find(item => item.id === countryChoice)

  const renderRegionSelectionByPlatform = useMemo(() => {
    switch (platform) {
      case FACEBOOK_PLATFORM:
        return (
          <FacebookGeolocationRegion
            selectedCountry={userChoiceCountry}
            name={SHOW_REGIONS}
            value={selectedRegions}
            setFieldValue={setFieldValue}
          />
        )
      case GOOGLE_PLATFORM:
        return (
          <GoogleGeolocationRegion
            selectedCountry={userChoiceCountry}
            name={SHOW_REGIONS}
            value={selectedRegions}
            setFieldValue={setFieldValue}
          />
        )
      case TIKTOK_PLATFORM:
        return <TiktokGeolocationRegion name={SHOW_REGIONS} value={selectedRegions} setFieldValue={setFieldValue} />
      case DV_360_PLATFORM:
        return <DV360GeolocationRegion name={SHOW_REGIONS} value={selectedRegions} setFieldValue={setFieldValue} />
      default:
        return null
    }
  }, [platform, selectedRegions, userChoiceCountry, setFieldValue])

  return (
    <RadioBlock
      setFieldValue={setFieldValue}
      id="radio_show_option_regions"
      name={SHOW_OPTION}
      value={SHOW_OPTION_REGIONS}
      selectedValue={values[SHOW_OPTION]}
      label={t('In specific regions or cities')}
      error={regionsError}
      touched={regionsTouched}
    >
      {showRegionsCountryFilter && (
        <Field placeholder="Country" formik={formik} name={SHOW_COUNTRY_CHOICE} options={formattedCountries} />
      )}
      {renderRegionSelectionByPlatform}
    </RadioBlock>
  )
}

export default RegionsRadioBlock
